import { render } from "./PageTournament.vue?vue&type=template&id=3216bdf0&scoped=true"
import script from "./PageTournament.vue?vue&type=script&lang=js"
export * from "./PageTournament.vue?vue&type=script&lang=js"

import "./PageTournament.vue?vue&type=style&index=0&id=3216bdf0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3216bdf0"]])

export default __exports__